import axios from 'axios';
import { datadogRum } from '@datadog/browser-rum';
import { loggerConfig } from 'config';
import { navigate, getPathname } from 'app/navigation';
import { attachConnectivity } from 'features/connectivity/lib/attachConnectivity';

const http = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        Accept: 'application/json',
    },
    proxy: {
        port: 4444,
    },
    maxContentLength: 1024 * 1024 * 20,
});

http.interceptors.request.use(function (config) {
    if (window.store) {
        const state = window.store.getState();
        const token = state?.session?.token;
        const jwt = state?.profile?.company?.jwt;

        config.headers.Authorization = token ? `Bearer ${jwt || token}` : '';
    }
    return config;
});

http.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (loggerConfig.LOGGING_ENABLED) {
            const rumError = new Error(error?.message || 'HTTP request failed');
            rumError.name = error?.name || 'AxiosError';
            datadogRum.addError(rumError, {
                errorName: error?.name,
                errorCode: error?.code,
                errorMessage: error?.message,
                url: error?.config?.url,
            });
        }

        const status = error?.response?.status;
        // The attempts-exhausted screen is a terminal state. Background refreshes
        // there (e.g. VerificationOptions' self-verify on mount) can come back 403
        // because checks are restricted/exhausted — a business outcome, not a
        // session expiry. Don't bounce the user off the terminal screen.
        const isOnAttemptsExhausted = getPathname()?.includes('attempts-exhausted');
        if (status === 401 && !isOnAttemptsExhausted) {
            navigate('/session-expired?session=expired');
        }

        return Promise.reject(error);
    }
);

// Attached after the interceptors above, so a request waits out an offline spell before its auth
// header is read, and a failure is logged before a GET is retried.
attachConnectivity(http, { retryGets: true });

export default http;
